import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'gameday-direct-deal-container',
  template: `
    <muni-gameday-deal class="deal-container"> </muni-gameday-deal>
  `,
  styleUrls: ['./deal-container.component.scss']
})
export class DealContainerComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true
    });
  }
}
